// SystemDeviceHardware Actions
import {
  SDHW_GET_LIST,
  SDHW_GET_LIST_SUCCESS,
  SDHW_GET_LIST_FAILURE,
  SDHW_GET_DATA,
  SDHW_GET_DATA_SUCCESS,
  SDHW_GET_DATA_FAILURE,
  SDHW_GET_READER_STATUS,
  SDHW_GET_READER_STATUS_SUCCESS,
  SDHW_GET_READER_STATUS_FAILURE,
  SDHW_TEST_READER,
  SDHW_TEST_READER_SUCCESS,
  SDHW_TEST_READER_FAILURE,
} from "./actionType";

// List
export const getSystemDeviceHardwareList = () => ({
  type: SDHW_GET_LIST,
});
export const getSystemDeviceHardwareListSuccess = (data) => ({
  type: SDHW_GET_LIST_SUCCESS,
  payload: data,
});
export const getSystemDeviceHardwareListFailure = (error) => ({
  type: SDHW_GET_LIST_FAILURE,
  payload: error,
});

// Single record
export const getSystemDeviceHardwareData = (data) => ({
  type: SDHW_GET_DATA,
  payload: data,
});
export const getSystemDeviceHardwareDataSuccess = (data) => ({
  type: SDHW_GET_DATA_SUCCESS,
  payload: data,
});
export const getSystemDeviceHardwareDataFailure = (error) => ({
  type: SDHW_GET_DATA_FAILURE,
  payload: error,
});

// Reader status (Stripe Terminal). payload: { id }
export const getSystemDeviceReaderStatus = (data) => ({
  type: SDHW_GET_READER_STATUS,
  payload: data,
});
export const getSystemDeviceReaderStatusSuccess = (data) => ({
  type: SDHW_GET_READER_STATUS_SUCCESS,
  payload: data,
});
export const getSystemDeviceReaderStatusFailure = (error) => ({
  type: SDHW_GET_READER_STATUS_FAILURE,
  payload: error,
});

// Test reader (cancel_action reachability probe). payload: { id }
export const testSystemDeviceReader = (data) => ({
  type: SDHW_TEST_READER,
  payload: data,
});
export const testSystemDeviceReaderSuccess = (data) => ({
  type: SDHW_TEST_READER_SUCCESS,
  payload: data,
});
export const testSystemDeviceReaderFailure = (error) => ({
  type: SDHW_TEST_READER_FAILURE,
  payload: error,
});
